import mbtiLong from './mbti-long';
import attachmentStyle from './attachment-style'

export default {
  'attachment-style': attachmentStyle,
  'mbti-long': mbtiLong,
}
